<template>
  <div>
    <p>What would you like to change about your order?</p>
    <tml-form form-name="amendForm">
      <tml-select
        :options="[
          { text: 'Add', value: 1 },
          { text: 'Remove', value: 2 }
        ]"
        field-name="amendOrder"
        @input="onSelect"
      />
    </tml-form>
    <div v-if="amendForm === 1">
      <p>We can make this happen, the best and fastest way to do this is by placing a new order.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpAmendForm',

  data() {
    return {
      amendForm: 0,
    };
  },

  methods: {
    onSelect(value) {
      this.amendForm = value;
      this.$emit('amend-order-value', this.amendForm);
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-top: 1em;
  margin-bottom: 1em;
}
</style>
